import { toSearchRequestDTO } from '../model/mappers/seatch-request.dto';

import type { DashboardSearchRequestModel } from '../model/types/search-request.model';
import type { ActionSummary, TriggeredItem } from '@/app/types/Dashboard';

import { apiSlice } from '@/app/api/api';


export const dashboardApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		actionDashboard: builder.query<
			{ summary: ActionSummary[]; triggered: TriggeredItem[] },
			DashboardSearchRequestModel
		>({
			queryFn: async (body, _api, _extraOptions, baseQuery) => {
				try {
					const [summaryResult, triggeredResult] = await Promise.all([
						baseQuery({
							url: `/data/actions/summary`,
							method: 'POST',
							body: toSearchRequestDTO(body),
						}),
						baseQuery({
							url: '/data/actions/triggered',
							method: 'POST',
							body: toSearchRequestDTO(body),
						}),
					]);

					if (summaryResult.error) {
						return { error: summaryResult.error };
					}

					if (triggeredResult.error) {
						return { error: triggeredResult.error };
					}

					return {
						data: {
							summary: summaryResult.data as ActionSummary[],
							triggered: triggeredResult.data as TriggeredItem[],
						},
					};
				} catch {
					return {
						error: { status: 500, data: 'Failed to process action dashboard request' },
					};
				}
			},
		}),
		getActionSummary: builder.query<ActionSummary[], DashboardSearchRequestModel>({
			query: (body) => ({
				url: `/data/actions/summary`,
				method: 'POST',
				body: toSearchRequestDTO(body),
			}),
		}),

		getTriggered: builder.query<TriggeredItem[], DashboardSearchRequestModel>({
			query: (body) => ({
				url: '/data/actions/triggered',
				method: 'POST',
				body: toSearchRequestDTO(body),
			}),
		}),
	}),
	overrideExisting: false,
});

export const { useGetActionSummaryQuery, useGetTriggeredQuery, useActionDashboardQuery } =
	dashboardApiSlice;
